import { GapTextStatus } from "@components/gap-text/gap-text.interface";
import { MarkMistakeElementStatus } from "@components/mark-mistakes-element/mark-mistakes-element.interface";
import { MultipleChoiceGapTextStatus } from "@components/multiple-choice-gap-text/multiple-choice-gap-text.interface";
import { ClozeTextPartKind, lessonInsights_Query$data } from "@relay/lessonInsights_Query.graphql";

export const createCalculateClozeTextStatus =
	(
		parts?: readonly {
			readonly id?: string;
			readonly kind: ClozeTextPartKind;
		}[],
		correctAnswers?: readonly string[],
		lastCheckedAnswers?: readonly string[],
	) =>
	(index: number): GapTextStatus => {
		const allParts = parts ?? [];
		let foundIndex = -1;
		for (let i = 0; i < allParts.length; i++) {
			const part = allParts[i];
			if (part.kind === "cloze") {
				foundIndex += 1;
			}
			if (i === index) {
				break;
			}
		}

		if (lastCheckedAnswers?.[foundIndex] === correctAnswers?.[foundIndex]) {
			return GapTextStatus.Correct;
		}
		return GapTextStatus.ActuallyCorrect;
	};

export const createCalculateMarkMistakesStatus =
	(
		correctMistakeIndices?: readonly number[],
		lastCheckedMistakeIndices?: readonly number[] | null,
	) =>
	(index: number) => {
		const isCorrect = correctMistakeIndices?.includes(index);
		const wasSelected = lastCheckedMistakeIndices?.includes(index);

		if (isCorrect && wasSelected) {
			return MarkMistakeElementStatus.Correct;
		}
		if (isCorrect) {
			return MarkMistakeElementStatus.ActuallyCorrect;
		}

		return MarkMistakeElementStatus.Wrong;
	};

export const createCalculateMultipleChoiceStatus =
	(
		correctAnswerIndices?: readonly number[],
		lastCheckedAnswerIndices?: readonly number[] | null,
	) =>
	(index: number) => {
		const isCorrect = correctAnswerIndices?.includes(index);
		const wasSelected = lastCheckedAnswerIndices?.includes(index);
		if (!isCorrect && wasSelected) {
			return MultipleChoiceGapTextStatus.Wrong;
		}

		if (isCorrect && wasSelected) {
			return MultipleChoiceGapTextStatus.Correct;
		}

		if (isCorrect) {
			return MultipleChoiceGapTextStatus.ActuallyCorrect;
		}

		return MultipleChoiceGapTextStatus.Default;
	};

export const createCalculateOrderStatus =
	(correctOrder?: readonly string[], lastSelectedOrder?: readonly string[] | null) =>
	(index: number): string => {
		const isCorrect = correctOrder?.[index] === lastSelectedOrder?.[index];
		return isCorrect ? "actuallyCorrect" : "correct";
	};

export const getClozeTextUntilFirstClozePart = (
	parts: lessonInsights_Query$data["Viewer"]["Learn"]["getAnswers"][number]["element"]["parts"] = [],
) => {
	const clozePartIndex = parts.findIndex((part) => part.kind === "cloze");
	if (clozePartIndex === -1) return `${parts.map((part) => part.text?.trim()).join("")}...`;

	return `${parts
		.slice(0, clozePartIndex)
		.map((part) => part.text?.trim())
		.join(" ")}...`;
};
